<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-sign`]" width="1em" height="1em" v-bind="$attrs"><path d="M15.5005 4.72294C16.0462 3.77786 17.2547 3.45405 18.1998 3.99969C19.1448 4.54534 19.4686 5.75381 18.923 6.6989L16.9577 10.1028C16.5279 10.8472 16.313 11.2195 16.0193 11.5071C15.7591 11.7618 15.4547 11.9671 15.1209 12.1128C14.7442 12.2773 14.3185 12.337 13.4673 12.4563L13.3041 12.4792L13.2423 12.3265C12.9201 11.5296 12.7589 11.1311 12.713 10.7226C12.6723 10.3607 12.6979 9.99444 12.7884 9.64171C12.8906 9.24351 13.1055 8.87129 13.5353 8.12686L15.5005 4.72294Z" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M9.55054 12.9902H6.08911C4.98454 12.9902 4.08911 13.8857 4.08911 14.9902C4.08911 16.0948 4.98454 16.9902 6.08911 16.9902H16.7108C17.8154 16.9902 18.7108 17.8857 18.7108 18.9902C18.7108 20.0948 17.8154 20.9902 16.7108 20.9902H6.08911" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorSign',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
